<template>
  <div class="settings">
    <PageMenu :linksList="linksComputedList" />
    <router-view />
  </div>
</template>

<script>
/* eslint-disable */
import {mapGetters} from 'vuex';
import PageMenu from '@/components/global/pageMenu';

export default {
  name: 'SettingsIndex',
  components: { PageMenu },
  data() {
    return {
      linksList: [
        {
          name: 'LBL_PAYERS',
          link: '/settings/shipping/payers',
        },
        {
          name: 'Locations',
          link: '/settings/shipping/locations',
        },
        {
          name: 'Notifications',
          link: '/settings/shipping/notifications',
        },
        {
          name: 'packaging',
          link: '/settings/shipping/packaging',
        },
        {
          name: 'Agreements',
          link: '/settings/shipping/agreements',
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'get_user_permission',
      'get_active_subaccount'
    ]),
    linksComputedList() {
      return [
        {
          name: 'LBL_PAYERS',
          link: '/settings/shipping/payers',
          visible: this.get_user_permission('settings/payer').view,
        },
        {
          name: 'Locations',
          link: '/settings/shipping/locations',
          visible: this.get_user_permission('settings/sender').view,
        },
        {
          name: 'Notifications',
          link: '/settings/shipping/notifications',
          visible: this.get_user_permission('settings/message').view,
        },
        {
          name: 'packaging',
          link: '/settings/shipping/packaging',
          visible: this.get_user_permission('settings/package').view,
        },
        {
          name: 'Agreements',
          link: '/settings/shipping/agreements',
          visible: this.get_user_permission('settings/account').view && parseInt(this.get_active_subaccount.backoffice_id) === 1,
        },
      ]
    },
  },
};
</script>
